module.exports = __webpack_public_path__ + "img/ycj120_0_75_172_i.prt.74906815.jpg";